import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    "& .custom-select": {
      overflowY: "auto"
    },
    bottomBar: {
      padding: "24px",
      display: "flex",
      justifyContent: "space-between",
      marginLeft: 0
    },
    header: {
      cursor: "pointer",
      padding: "0.8rem 1.6rem",
      background: theme.palette.gardient.medium,
      colors: "white",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "60px",
      "& .MuiTypography-root": {
        color: "white"
      },
      "& .MuiTypography-h6": {
        lineHeight: "2.4rem",
        fontSize: "18px"
      }
    },
    searchBox: {
      "& .MuiGrid-item": {
        maxWidth: "20%",
        flexBasis: "20%",
        "&:nth-child(1), &:nth-child(2)": {
          maxWidth: "50%",
          flexBasis: "50%"
        },
        "&:nth-child(13), &:nth-child(14), &:nth-child(15)": {
          backgroundColor: "#f5f7fe",
          borderRadius: 4,
          padding: "12px 12px 0px 12px"
        },
        "&:nth-child(13)": {
          marginLeft: 10
        },
        "&:nth-child(14)": {
          padding: "12px 0px 0px 0px"
        },
        "&:nth-child(15)": {
          marginRight: "-10px",
          paddingRight: "10px",
          borderRight: "20px solid #fff"
        },
        "&:nth-child(18)": {
          maxWidth: "30%",
          flexBasis: "30%"
        }
      },
      "& .MuiFormGroup-root": {
        "& .MuiFormControlLabel-root": {
          "&:last-child": {
            marginRight: "0px"
          }
        }
      },
      "& .MuiRadio-root": {
        padding: "14px 10px"
      },
      "& .MuiFormControl-root": {
        height: "36px",
        fontSize: "14px !important"
      },
      padding: "24px 24px 0px 24px",
      "& .MuiSvgIcon-root": {
        fontSize: 70,
        borderRadius: 20
      }
    },
    divider: {
      padding: "0px 24px 0px 24px"
    },
    searchBoxMargin: {
      marginTop: "2rem"
    },
    arrowIcon: {
      color: "#FFFFFF"
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    },
    flex: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    actionButton: {
      width: "132px",
      fontSize: "1.6rem",
      height: "40px",
      "& .MuiButton-label": {
        fontWeight: 700
      }
    },
    resetButton: {
      width: "132px",
      height: "40px",
      fontSize: "1.4rem",
      "& .MuiButton-label": {
        fontWeight: 400
      }
    },
    icon: {
      marginRight: "1.1rem"
    },
    checkbox: {
      backgroundColor: "transparent",
      boxShadow: "none !important"
    },
    radioGroup: {
      flexDirection: "row"
    },
    selectField: {
      height: "36px",
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800]
      }
    },
    disabled: {
      border: "1px solid #999999",
      backgroundColor: "#cccccc",
      color: "#666666"
    },
    required: {
      color: theme.palette.error.main,
      "& :after": {
        content: "*"
      }
    }
  }),
  { name: "OrderFilterSection" }
);

export default useStyles;
